module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleD6.2fcb5d41.png";